export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const removeWhitespace = (str) => {
  return str.replace(/\s/g, '')
}
